import { Routes } from '@angular/router';
import { ContentComponent } from './shared/component/layout/content/content.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgetPasswordComponent } from './auth/forget-password/forget-password.component';
import { authGuard, routePermissionGuard } from './auth.guard';
import { Error404Component } from './shared/component/error-page/error404/error404.component';
import { NoAccessComponent } from './shared/component/error-page/no-access/no-access.component';
import { pages } from './component/pages/pages.routes';


export function buildAppRoutes(): Routes {

  return [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: ContentComponent,
    children: pages,
    canActivate: [authGuard, routePermissionGuard],
    canActivateChild: [authGuard, routePermissionGuard],
  },
  {
    path: 'auth/forgot-password',
    component: ForgetPasswordComponent,
    pathMatch: 'full'
  },
  {
    path: 'auth/login',
    component: LoginComponent,
    pathMatch: 'full'
  },
  {
    path: 'error-404',
    component: Error404Component,
    pathMatch: 'full'
  },
  {
    path: 'no-access',
    component: NoAccessComponent,
    pathMatch: 'full'
  },
  // {
  //   path: '**',
  //   redirectTo: 'error-404'
  // }
];
}
